import React from 'react'
import { Box, TextField, Chip, Checkbox, FormControlLabel, Button } from '@mui/material'
import { IconSeeker, ButtonLoadingSeeker, CardSeeker } from '@ui-seeker/core'
import {
    filterDateFrom,
    filterDateTo,
    filterQuick,
    excludePropagated,
    isLoadingTable,
    clearFilters,
    applyQuickFilter
} from './@signals'
import { useUserStats } from './@hooks'

const QUICK_FILTER_OPTIONS = [
    { value: 'today', label: 'Today' },
    { value: 'thisWeek', label: 'This Week' },
    { value: 'thisMonth', label: 'This Month' },
    { value: 'last30Days', label: 'Last 30 Days' },
    { value: 'none', label: 'Custom' }
]

export default function UserStatsFilters() {
    const { fetchUserStats } = useUserStats()

    const handleSearch = () => {
        fetchUserStats()
    }

    const handleClear = () => {
        clearFilters()
        fetchUserStats()
    }

    const handleQuickFilter = (value) => {
        applyQuickFilter(value)
        handleSearch()
    }

    return (
        <CardSeeker>
            <Box sx={{ p: 2 }}>
                {/* Quick Filters */}
                <Box sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <IconSeeker icon="clock" size="sm" />
                        <Box component="span" sx={{ fontSize: '0.875rem', fontWeight: 500 }}>Date Range</Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {QUICK_FILTER_OPTIONS.map(opt => (
                            <Chip
                                key={opt.value}
                                label={opt.label}
                                onClick={() => handleQuickFilter(opt.value)}
                                color={filterQuick.value === opt.value ? 'primary' : 'default'}
                                variant={filterQuick.value === opt.value ? 'filled' : 'outlined'}
                                size="small"
                            />
                        ))}
                    </Box>
                </Box>

                {/* Custom Date Range - only visible when Custom is selected */}
                {filterQuick.value === 'none' && (
                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                        <TextField
                            size="small"
                            label="From"
                            type="date"
                            value={filterDateFrom.value || ''}
                            onChange={(e) => filterDateFrom.value = e.target.value || null}
                            InputLabelProps={{ shrink: true }}
                            sx={{ width: 180 }}
                        />
                        <TextField
                            size="small"
                            label="To"
                            type="date"
                            value={filterDateTo.value || ''}
                            onChange={(e) => filterDateTo.value = e.target.value || null}
                            InputLabelProps={{ shrink: true }}
                            sx={{ width: 180 }}
                        />
                    </Box>
                )}

                {/* Additional options */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={excludePropagated.value}
                                onChange={(e) => excludePropagated.value = e.target.checked}
                                size="small"
                            />
                        }
                        label="Exclude propagated mappings"
                    />

                    {/* Action buttons */}
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleClear}
                            startIcon={<IconSeeker icon="xmark" size="sm" />}
                        >
                            Clear
                        </Button>
                        <ButtonLoadingSeeker
                            variant="contained"
                            size="small"
                            onClick={handleSearch}
                            loading={isLoadingTable.value}
                            startIcon={<IconSeeker icon="search" size="sm" />}
                        >
                            Apply
                        </ButtonLoadingSeeker>
                    </Box>
                </Box>
            </Box>
        </CardSeeker>
    )
}
